import { render, staticRenderFns } from "./PeriodeEdit.vue?vue&type=template&id=64af84a7&"
import script from "./PeriodeEdit.js?vue&type=script&lang=js&"
export * from "./PeriodeEdit.js?vue&type=script&lang=js&"
import style0 from "./PeriodeEdit.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports